/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {RecipeFinderRowSkeleton} from "./RecipeFinderRowSkeleton";

export const RecipeFinderSkeleton = () => (
    <div className="row">{[...Array(3)].map((item, i) => <RecipeFinderRowSkeleton key={i}/>)}</div>
)
